<template>
  <div>
    <img src="static/img/participant-portal/green-check-large.svg" class="ICN---green-check-large" />
    <div class="instruction_title text-center" v-translate:titleActivityText="lang">
      {{ titleActivityText }}
    </div>
    <div v-if="question.imageUrl" class="imageBox text-center" @click.once="$emit('onClick', question)">
      <img width="100%" class="img-size" :src="question.imageUrl" />
    </div>
    <div class="instruction_info text-justify mt-5 pt-5" v-html="question.formattedInformation"></div>
  </div>
</template>

<script>
import { Widget } from "@/components/services/participant-service";
export default {
  name: "instruction",
  props: ["lang", "question", "isFieldDisabled", "isLegacyStudy"],
  data() {
    return {
      widget: new Widget()
    };
  },
  mounted() {},
  computed: {
    titleActivityText() {
      return this.widget.translate("activity_complete", this.question.title);
    },
    componentData() {
      return this.question.constraints;
    }
  },
  methods: {}
};
</script>

<style scoped>
.ICN---green-check-large {
  width: 86px;
  height: 86px;
  margin: auto;
  object-fit: contain;
  left: calc(50% - 43px);
  position: relative;
}
</style>
